import PropTypes from 'prop-types'
import {useFocusLayer} from '../../../../../store/hooks/focusLayer'
import {visualOptions} from '../../../helper'
import UniqueHouseHoldsClusterLayer from './UniqueHouseHoldsClusterLayer'
import HeatMapLayer from './HeatMapLayer'
import {useOutreachFilters} from '../../../../../store/hooks/useOutreachFilters'
import {getGroupedData, getGroupedDataByPersona} from '../helpers'
import {useMemo} from 'react'
import {usePersona} from '../../../../../store/hooks/persona'
import {useConfig} from '../../../../../store/hooks/config'

const VisualLayer = ({data = {}}) => {
  const {selectedFocusLayer} = useFocusLayer()
  // New filter management system for outreach
  const {isOutreachActive, selectedOptionsWithConfig} = useOutreachFilters()
  const {personasConfig} = useConfig()
  const {personas, personasToggle} = usePersona()

  // Memoize source data calculation
  const sourceData = useMemo(() => {
    if (isOutreachActive) {
      return getGroupedData(data, selectedOptionsWithConfig, selectedFocusLayer)
    } else if (personasToggle) {
      return getGroupedDataByPersona(data, personas, personasConfig)
    }
    return data
  }, [data, isOutreachActive, selectedOptionsWithConfig, selectedFocusLayer, personasToggle, personas, personasConfig])

  // Render the appropriate layer based on the selected focus layer
  switch (selectedFocusLayer) {
    case visualOptions[1].value:
      return (
        <UniqueHouseHoldsClusterLayer
          data={sourceData}
          isOutreachSimulationSelected={isOutreachActive}
          isPersonaSelected={personasToggle}
        />
      )
    case visualOptions[0].value:
      return (
        <HeatMapLayer
          data={sourceData}
          isOutreachSimulationSelected={isOutreachActive}
          isPersonaSelected={personasToggle}
        />
      )
    default:
      return null
  }
}

VisualLayer.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
}

export default VisualLayer

/**
 * List of functions and their purpose:
 *
 * - VisualLayer: Dynamically renders either a clustered or heatmap visualization layer based on the selected focus layer and data.
 */
